import { Text } from "components/Typography/text.styled";
import { useTranslation } from "react-i18next";
import {
  CenteredInfo,
  OrgStructureModalBody,
} from "./organizationalStructure.styled";
import { FontFamily } from "config/font";
import Modal from "@material-ui/core/Modal/Modal";
import { TopModal } from "../general/topModal/topModal.component";

type Props = {
  showInfoModal: boolean;
  setShowInfoModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const InfoModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={props.showInfoModal}
      onClose={() => {
        props.setShowInfoModal(false);
      }}
    >
      <OrgStructureModalBody style={{ width: 650 }}>
        <TopModal
          title=""
          setClose={() => props.setShowInfoModal(false)}
          marginLeft={30}
        />
        <CenteredInfo>
          <Text fontFamily={FontFamily.MontserratSemiBold}>
            {t("OrganizationalStructure.OrganizationalStructure")}
          </Text>
          <Text style={{ width: 500, marginTop: 0 }}>
            {t("OrganizationalStructure.OrgStructureInfo")}
          </Text>
        </CenteredInfo>
      </OrgStructureModalBody>
    </Modal>
  );
};
